export class Webp{
   
    /**
     * Test and return true if the browser support webp images
     * @returns boolean
     */
    public static support(): boolean{
        let supporte = this.suporteWebp();
        if(supporte != undefined){
            return supporte;
        }
        var elem = document.createElement('canvas');
        var result = !!(elem.getContext && elem.getContext('2d')) ? elem.toDataURL('image/webp').indexOf('data:image/webp') == 0 : false;
        if(!result){
            result = this.checkBrowserWebp();
        }
        this.suporteWebp(result);
        return this.suporteWebp()??false;
    }

    /**
     * Set/Get the browser support for webp images
     * @param value 
     * @returns boolean|undefined
     */
    public static suporteWebp(value: boolean|undefined|null = null): boolean|undefined{
        let win: any = (window as any);
        if(value !== null){
            win._suporteWebpST = value;
        }
        return win._suporteWebpST ?? undefined;
    }

    /**
     * Detect the browser name and version 
     * @returns {name: string, version: number}
     */
    public static browserVersion(): {name: string, version: number}{
        var ua= navigator.userAgent;
        var tem; 
        var M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if(/trident/i.test(M[1])){
            tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
            return {name: 'IE', version: parseFloat(tem[1]??'0.0')};
        }
        if(M[1]=== 'Chrome'){
            tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
            if(tem!= null){
                return {name: tem[1].replace('OPR', 'Opera'), version: parseFloat(tem[2]??'0.0')};
            }
        }
        let result  = M[2] ? {name: M[1], version: parseFloat(M[2])}: {name: navigator.appName,   version: parseFloat(navigator.appVersion)};
        if((tem= ua.match(/version\/(\d+)/i))!= null){
            result.version = parseFloat(tem[1]);
        }
        return result;
    }

    /**
     * Check webp support by the browser version
     * @returns boolean
     */
    public static checkBrowserWebp(): boolean {
        let browser: {name: string, version: number} = this.browserVersion();
        switch(browser.name.toLocaleLowerCase()){
            case 'safari':
                return browser.version >= 16;
            case 'chrome':
                return browser.version >= 32;
            case 'firefox':
                return browser.version >= 65;
            case 'opera':
                return browser.version >= 20;
            default:
                return false;
        }
    }
}